<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "@/router/index.js";
import moment from "moment";
import YTAddress from "@/components/YTAddress/index.vue";
import YTFormDialog from "@/components/YTFormDialog/index.vue";
import {listTenantOrganizeIgnore} from "@/api/tenant/tenant.js";
import {listTenant} from "@/api/user/user.js";

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  goodsName: null,
  orderNo: null,
  phone: null,
  userId: null,
  tenantId: null,
  tenantName: null,
  storeId: null,
  storeName: null,
  time: [],
  state: null
});
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {

    }
    // const res = await listTenantOrganizeIgnore(page, param);
    tableData.value = [
      {
        orderNo: "114514155151",
        avatar: "",
        userId: "155151114514",
        nickname: "苍角今天饿了没",
        phone: "17612345678",
        goodsName: "Spa护理",
        tenantName: "杜伊正骨",
        storeName: "杜伊正骨",
        paymentTime: "2025-10-30 12:20",
        receivedAmount: 350
      }
    ]
    // tableData.value = res.list
    // total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.provinceCode = null
  formData.cityCode = null
  formData.districtCode = null
  formData.time = []
  formData.address = null
  handleSearch('btnSearch')
}
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  formData.address = data.value
  formData.provinceCode = data.value[0]
  formData.cityCode = data.value[1]
  formData.districtCode = data.value[2] ? data.value[2] : null
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '订单编号', key: 'orderNo', nowrap: true },
  { title: '用户头像', key: 'avatar', nowrap: true },
  { title: '用户ID', key: 'userId', nowrap: true },
  { title: '用户昵称', key: 'nickname', nowrap: true },
  { title: '注册手机号', key: 'phone', nowrap: true },
  { title: '商品名称', key: 'goodsName', nowrap: true },
  { title: '所属商家', key: 'tenantName', nowrap: true },
  { title: '车店', key: 'storeName', nowrap: true },
  { title: '订单付款时间', key: 'paymentTime', nowrap: true },
  { title: '订单金额', key: 'receivedAmount', nowrap: true },
  { title: '状态', key: 'state', nowrap: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*商家列表相关*/
// 商家列表
const tenantList = ref([])
// 商家列表加载状态
const tenantLoading = ref(false)
// 商家总数
const totalTenant = ref(0)
// 商家列表当前页数
const pageTenant = ref(1)
// 商家列表页长
const pageSizeTenant = ref(5)
// 处理选择商家改变
const handleTenantChange = (e) => {
  const tenant = tenantList.value.find(item => item.tenantId === e)
  formData.tenantId = tenant.tenantId
  formData.tenantName = tenant.name
}
// 处理商家翻页
const handleChangeTenantPage = (e) => {
  pageTenant.value = e
  handleGetTenantList()
}
// 搜索关键字缓存
const keywordTenant = ref()
// 搜索触发函数
const handleRemoteSearch = (keyword) => {
  keywordTenant.value = keyword
  pageTenant.value = 1
  handleGetTenantList()
}
// 获取商家列表
const handleGetTenantList = async () => {
  tenantLoading.value = true
  const page = {
    page: pageTenant.value,
    pageSize: pageSizeTenant.value,
  }
  let param = {
    keyword: keywordTenant.value || null
  }
  const res = await listTenant(page, param)
  tenantList.value = res.list
  totalTenant.value = parseInt(res.total)
  console.log(res)
  tenantLoading.value = false
}

/*服务商列表相关*/
// 服务商列表
const storeList = ref([])
// 服务商列表加载状态
const storeLoading = ref(false)
// 服务商总数
const totalStore = ref(0)
// 服务商列表当前页数
const pageStore = ref(1)
// 服务商列表页长
const pageSizeStore = ref(5)
// 处理选择服务商改变
const handleStoreChange = (e) => {
  const store = storeList.value.find(item => item.storeId === e)
  formData.storeId = store.storeId
  formData.storeName = store.name
}
// 处理服务商翻页
const handleChangeStorePage = (e) => {
  pageStore.value = e
  handleGetStoreList()
}
// 搜索关键字缓存
const keywordStore = ref()
// 搜索触发函数
const handleRemoteStoreSearch = (keyword) => {
  keywordStore.value = keyword
  pageStore.value = 1
  handleGetStoreList()
}
// 获取服务商列表
const handleGetStoreList = async () => {
  storeLoading.value = true
  const page = {
    page: pageStore.value,
    pageSize: pageSizeStore.value,
  }
  let param = {
    keyword: keywordStore.value || null,
    type: "BIKE_STORE",
  }
  const res = await listTenantOrganizeIgnore(page, param)
  storeList.value = res.list
  totalStore.value = parseInt(res.total)
  console.log(res)
  storeLoading.value = false
}

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="width: 100%;text-align: left"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <div class="flex_left flex_warp">
        <el-form-item label="商品名称：" prop="goodsName">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.goodsName" placeholder="商品名称"></el-input>
        </el-form-item>
        <el-form-item label="订单编号：" prop="orderNo">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.orderNo" placeholder="订单编号"></el-input>
        </el-form-item>
        <el-form-item label="注册手机号：" prop="phone">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.phone" placeholder="注册手机号"></el-input>
        </el-form-item>
        <el-form-item label="用户ID：" prop="userId">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.userId" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item label="所属商家：" prop="tenantId">
          <el-select
              class="mg_r_2"
              v-model="formData.tenantId"
              placeholder="所属商家"
              style="width: 300px;"
              :loading="tenantLoading"
              @change="handleTenantChange"
              filterable
              remote
              remote-show-suffix
              :remote-method="handleRemoteSearch"
          >
            <el-option
                v-for="item in tenantList"
                :key="`tenantId${item.tenantId}`"
                :label="item.name"
                :value="item.tenantId"
            />
            <template v-if="!loading && !tenantList.some(res => res.tenantId === formData.tenantId) && formData.tenantId" #header>
              当前已选：
              <el-option
                  :label="formData.tenantName"
                  :value="formData.tenantId"
              />
            </template>

            <template #footer>
              <div class="flex_center">
                <el-pagination
                    size="small"
                    background
                    layout="prev, pager, next"
                    :total="totalTenant"
                    class="mt-4"
                    v-model:current-page="pageTenant"
                    v-model:page-size="pageSizeTenant"
                    @current-change="handleChangeTenantPage"
                />
              </div>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="车店：" prop="storeId">
          <el-select
              class="mg_r_2"
              v-model="formData.storeId"
              placeholder="车店"
              style="width: 300px;"
              :loading="storeLoading"
              @change="handleStoreChange"
              filterable
              remote
              remote-show-suffix
              :remote-method="handleRemoteStoreSearch"
          >
            <el-option
                v-for="item in storeList"
                :key="`storeId${item.storeId}`"
                :label="item.name"
                :value="item.storeId"
            />
            <template v-if="!loading && !storeList.some(res => res.storeId === formData.storeId) && formData.storeId" #header>
              当前已选：
              <el-option
                  :label="formData.storeName"
                  :value="formData.storeId"
              />
            </template>

            <template #footer>
              <div class="flex_center">
                <el-pagination
                    size="small"
                    background
                    layout="prev, pager, next"
                    :total="totalStore"
                    class="mt-4"
                    v-model:current-page="pageStore"
                    v-model:page-size="pageSizeStore"
                    @current-change="handleChangeStorePage"
                />
              </div>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="订单时间：" prop="time">
          <el-date-picker
              class="mg_r_2"
              v-model="formData.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          />
        </el-form-item>
        <el-form-item label="订单状态：" prop="state">
          <el-select class="mg_r_2" v-model="formData.state" placeholder="订单状态" style="width: 300px">
            <el-option
                v-for="item in certificationTypeEnum"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.avatar="{ item }">
            <img style="width: 34px;height: 34px;border-radius: 34px;" :src="item.avatar ? item.avatar : 'https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/table/table/default_avatar.svg'">
          </template>

          <template v-slot:item.receivedAmount="{item}">
            {{item.receivedAmount ? `￥${item.receivedAmount}` : "—"}}
          </template>

          <template v-slot:item.state="{item}">
            <div v-if="item.state === 'VALID'">正常</div>
            <div v-else-if="item.state === 'LOGOUT'">注销</div>
            <div v-else>-</div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
::marker {
  content: none;
}
</style>
